import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridCellRenderer } from '@softapps/core';
import { Account } from './account';

@Component({
  selector: 'soft-account-column',
  imports: [],
  template: `
    <div class="flex flex-col">
      <span class="soft-overline !mb-0">{{ value()?.nummer }}</span>
      <span class="text-sm">{{ value()?.kurzbez }}</span>
    </div>`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountColumnComponent<TRow extends object> extends GridCellRenderer<TRow, Account>{

}
